import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-010b9089"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column m-4 py-4 align-middle" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-start header" }, "Thank you for trying OTC Pro"),
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-start text" }, [
    /*#__PURE__*/_createTextVNode(" You've reached the end of your free trial period. We really hope you enjoyed using OTC Pro and have "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("gained an understanding of the value that real-time scanning has on your trading success. "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("To continue using OTC Pro please select one of our plans. ")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_collapsable_container = _resolveComponent("collapsable-container")!

  return (_openBlock(), _createBlock(_component_collapsable_container, { border: false }, {
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }))
}